import { ILimit, Currency } from "@/entities";

export class Limit implements ILimit {
  readonly currency?: Currency;
  readonly amount?: number;

  constructor(data: ILimit) {
    this.currency = data.currency ? new Currency(data.currency) : undefined;
    this.amount = data.amount;
  }
}
